/* ==========================================================================
   Collection Hub — Size/Color filter interactions + video tile autoplay
   ========================================================================== */
(function () {
  function initFilters() {
    var containers = document.querySelectorAll('[data-collection-hub-filters]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var grid = document.querySelector('.collection-matrix');
      if (!grid) return;

      var toggles = container.querySelectorAll('[data-filter-toggle]');
      var clearBtn = container.querySelector('[data-filter-clear]');
      var resultCount = container.querySelector('[data-filter-result-count]');

      // Round 40: fixes "filter only shows results for the page, not the
      // entire collection" (Randy). applyFilters() below only ever looks at
      // .product__grid-item nodes that are actually in the DOM right now —
      // on a big collection (some run into the hundreds of products) that's
      // just the first "page" (48 items) until the shopper manually clicks
      // "Load More" repeatedly. So checking a Size/Color box was silently
      // filtering only that first batch and reporting a tiny, misleading
      // count, even though far more matches existed further down the
      // collection. loadRemainingPages() below loads the rest of the
      // collection in the background until it's fully loaded, so filtering
      // — and the count shown — reflects every product in the collection,
      // not just whatever had loaded so far. allLoaded gates it to run at
      // most once per grid (reset on a Sort/Tag swap below, since that
      // fetches a fresh page 1).
      var allLoaded = false;
      // Guards against two entry points (the toggle-open handler and the
      // checkbox-change handler below both call loadRemainingPages()) each
      // starting their OWN independent load chain at once. loadRemainingPages()
      // is the public entry point (only starts a chain if one isn't already
      // running).
      var loadInProgress = false;
      // Used by stepLoad() (the Round 40 fallback loader below) to give up
      // after repeated stalls rather than hang forever. Reset to 0 the
      // moment real progress is seen.
      var consecutiveStalls = 0;

      var LOAD_MORE_SELECTOR = '[data-load-more], [data-load-infinite], [data-load-more-infinite]';

      // Round 41 fix (kept for the stepLoad() fallback below): a
      // programmatic loadMoreBtn.click() dispatches a real click event that
      // bubbles all the way up to document — including into the "click
      // outside the filter closes the panel" listener further down. Since
      // the Load More button lives outside `container`, that listener saw
      // every synthetic click as "the shopper clicked away" and closed
      // whichever Size/Color panel was open. Setting this flag around a
      // synthetic click lets the document listener recognize and ignore
      // clicks WE fired, while still closing the panel normally for a real
      // click elsewhere by the shopper. turboLoad() below never clicks
      // anything, so this only matters when stepLoad() is in use.
      var suppressOutsideClose = false;

      // Round 42: fixes "it works but it's slow" (Randy). Round 40 loaded
      // the rest of the collection by clicking the theme's real "Load More"
      // button and waiting for each page to fully round-trip before
      // starting the next one — one page at a time, start to finish. But
      // every page here is just this same collection URL with `?page=N`
      // (see utilities.js's loadNextPage, which is what a real click runs),
      // and the page numbers are entirely predictable up front once we know
      // which page the button is currently pointing at. turboLoad() below
      // fetches several of those pages directly and in parallel instead of
      // waiting on each one in turn — same requests the button's own click
      // would make, just fired several at a time — which cuts the total
      // wait roughly in proportion to how many run at once instead of
      // end-to-end per page. The button is hidden for the duration so a
      // shopper can't also trigger the theme's own click handler on a
      // now-stale href while this is mid-flight (we never update the
      // button's href ourselves — only stepLoad()'s real clicks do that).
      // If a page genuinely fails to fetch after retries — a real
      // network/server error, not just "this page is past the end of the
      // collection" (that's an expected, normal empty result) —
      // turboFallback() hands off to stepLoad(), the exact click-and-poll
      // loader Round 40 already proved reliable, rather than risk a subtle
      // new bug in a second from-scratch retry scheme.
      var TURBO_BATCH_SIZE = 6;
      var TURBO_MAX_RETRIES = 2;

      function refreshReviewBadges() {
        // Mirrors what the theme's own "Load More" success handler does
        // after adding real products (see utilities.js loadNextPage) —
        // without this, star-rating badges on turbo-loaded items would
        // never fetch their review data and would stay blank.
        if (
          window.PXUTheme &&
          window.PXUTheme.productReviews &&
          typeof window.PXUTheme.productReviews.init === 'function'
        ) {
          window.PXUTheme.productReviews.init();
        }
      }

      function turboFallback(loadMoreBtn, resumeFromPage) {
        var btn = document.querySelector(LOAD_MORE_SELECTOR) || loadMoreBtn;
        if (btn && resumeFromPage) {
          try {
            var resumeUrl = new URL(btn.getAttribute('href') || '', window.location.origin);
            resumeUrl.searchParams.set('page', resumeFromPage);
            btn.setAttribute('href', resumeUrl.pathname + resumeUrl.search);
          } catch (e) {}
        }
        if (btn) btn.classList.remove('is-hidden');
        stepLoad();
      }

      function turboLoad(loadMoreBtn) {
        var startUrl;
        try {
          startUrl = new URL(loadMoreBtn.getAttribute('href') || '', window.location.origin);
        } catch (e) {
          turboFallback(loadMoreBtn);
          return;
        }

        // Fetching the full HTML page for every one of those pages — the
        // same request the button's own click makes — means DOMParser has
        // to build out an entire document (header, footer, every other
        // section on the page) just so the code below can throw all of
        // that away and keep the handful of .product__grid-item nodes
        // inside it. Live testing after the fetch-in-parallel change above
        // showed the fetches themselves resolving quickly, but the page
        // still freezing for multi-second stretches — DOMParser parsing
        // several full pages back to back was the real bottleneck, not the
        // network. Shopify's built-in section-rendering endpoint
        // (?section_id=<id>) returns ONLY that one section's markup, so
        // both the download and the parse are a fraction of the size. The
        // section id is read from the DOM already on the page (the same
        // `shopify-section-<id>` wrapper Shopify puts around every section,
        // or the data-section-id script tag in collection__main.liquid as
        // a backup) — if neither is found for any reason, pageUrl() below
        // just omits it and falls back to the previous full-page fetch,
        // which still works, only slower.
        var sectionWrapper = grid.closest('[id^="shopify-section-"]');
        var sectionId = sectionWrapper ? sectionWrapper.id.replace('shopify-section-', '') : null;

        // Round 44 (see the batch-size comment below): the page can carry
        // SEVERAL `[data-section-id][data-section-data]` script tags at once
        // (mega-menu, ajax cart, header, this collection section, ...) — an
        // unscoped querySelector() here grabbed whichever came first in the
        // DOM, which in live testing turned out to be an unrelated mega-menu
        // section whose JSON has no `number_of_pages` at all, silently
        // defeating the optimization below every time (confirmed: it kept
        // falling back to the old fixed batch size without erroring). Only
        // this collection section's own schema (collection__main.liquid)
        // actually includes `number_of_pages`, so scanning every match for
        // the first one that parses with that key present finds the right
        // one reliably regardless of DOM order — and doubles as the
        // `sectionId` fallback source too, so both only need one pass.
        var sectionData = null;
        var sectionDataEls = document.querySelectorAll('script[data-section-id][data-section-data]');
        for (var sdi = 0; sdi < sectionDataEls.length; sdi++) {
          try {
            var parsedSectionData = JSON.parse(sectionDataEls[sdi].textContent);
            if (parsedSectionData && typeof parsedSectionData.number_of_pages !== 'undefined') {
              sectionData = parsedSectionData;
              if (!sectionId) sectionId = sectionDataEls[sdi].getAttribute('data-section-id');
              break;
            }
          } catch (e) {}
        }

        loadMoreBtn.classList.add('is-hidden');
        var nextPage = parseInt(startUrl.searchParams.get('page'), 10) || 2;
        var reachedEnd = false;

        // Round 44: fixes "can you make the filters work any faster" (Randy).
        // Fetching in fixed batches of TURBO_BATCH_SIZE meant a big collection
        // still needed several sequential waves (Lingerie's ~17 pages took 3
        // waves of 6) — each wave still has to fully finish before the next
        // one starts. collection__main.liquid already renders the real total
        // page count into the page's own data-section-data JSON block
        // (`"number_of_pages": {{ paginate.pages | json }}`), so rather than
        // guess a batch size, read it directly (via sectionData above) and
        // fetch every remaining page in ONE wave whenever it's available —
        // cutting 3 sequential waves down to 1 for the worst-case collection
        // tested. Falls back to the old fixed TURBO_BATCH_SIZE when the count
        // isn't available at all.
        var batchSize = TURBO_BATCH_SIZE;
        var knownTotalPages = null;
        if (sectionData) {
          var totalPages = parseInt(sectionData.number_of_pages, 10);
          if (totalPages > 0) {
            knownTotalPages = totalPages;
            var remainingPages = totalPages - nextPage + 1;
            if (remainingPages > batchSize) {
              // Round 45: was capped at 60. Randy reported this optimization
              // undercounting filter results (e.g. "only showing 37 red
              // items" on a collection with far more) and loading slowly on
              // mobile — root-caused to a burst of this many simultaneous
              // same-origin fetches occasionally getting back a truncated/
              // empty response (more likely under mobile network conditions,
              // but reproducible outright), which the code below mistook for
              // "the collection ended here." Lowering the cap reduces how
              // large that simultaneous burst ever gets, and pairs with the
              // fetchPage()/runBatch() hardening below, which is the actual
              // fix for the undercounting — this cap alone wouldn't have
              // been enough, since Lingerie's own 16-page batch was already
              // well under the old 60 cap when the bug was reproduced.
              batchSize = Math.min(remainingPages, 24);
            }
          }
        }

        function pageUrl(pageNum) {
          var u = new URL(startUrl.href);
          u.searchParams.set('page', pageNum);
          if (sectionId) u.searchParams.set('section_id', sectionId);
          return u.pathname + u.search;
        }

        function fetchPage(pageNum, attempt) {
          return fetch(pageUrl(pageNum), { credentials: 'same-origin' })
            .then(function (res) {
              if (!res.ok) throw new Error('HTTP ' + res.status);
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              // Round 46: fixes Randy's "black filter takes a very long
              // time to load" report. Every product thumbnail includes a
              // <noscript><img src="..."></noscript> fallback for when JS
              // is disabled (the real, non-lazy image, meant only for that
              // no-JS/SEO case). A document created by DOMParser has
              // scripting disabled per spec, so that <noscript> tag's
              // contents get parsed as a genuine, already-real <img>
              // element instead of staying inert markup — and importing it
              // below via document.importNode() spliced a second,
              // full-size, non-lazy image into the live page for every
              // single turbo-loaded product, invisible (noscript content is
              // display:none) but still fully downloaded by the browser.
              // Confirmed live: this alone doubled the number of eager
              // image downloads a big background load triggered. Stripping
              // every <noscript> out of the fetched fragment before use
              // removes that duplicate — the real, lazy-loaded <img> right
              // next to it is untouched and still shows normally.
              var noscripts = doc.querySelectorAll('noscript');
              for (var ni = 0; ni < noscripts.length; ni++) noscripts[ni].remove();
              var items = Array.prototype.slice.call(doc.querySelectorAll('.product__grid-item'));
              // Round 45: fixes Randy's "only 37 red items" report. Once
              // knownTotalPages says this exact page number should exist and
              // have products, an empty result for it is far more likely a
              // transient glitch — a burst of parallel requests occasionally
              // getting a truncated/short-circuited response back — than a
              // genuine end-of-collection signal, since collections don't
              // skip pages. Treat that case exactly like a network error and
              // give it the same retries, instead of trusting it immediately
              // (which is what let one flaky page silently truncate the
              // whole load). A page at or past the known total, or when the
              // total isn't known at all (the pre-Round-44 case), keeps
              // trusting an empty result right away — that's still the only
              // signal available there.
              if (
                items.length === 0 &&
                knownTotalPages &&
                pageNum <= knownTotalPages &&
                attempt < TURBO_MAX_RETRIES
              ) {
                return fetchPage(pageNum, attempt + 1);
              }
              return items;
            })
            .catch(function (err) {
              if (attempt < TURBO_MAX_RETRIES) {
                return fetchPage(pageNum, attempt + 1);
              }
              throw err;
            });
        }

        // Round 46: also fixes Randy's "black filter takes a very long
        // time to load" report, alongside the <noscript> fix above. Even
        // with that duplicate gone, live testing found the theme's own
        // lazysizes library was still eagerly loading essentially every
        // turbo-appended image regardless of how far below the fold it
        // was — confirmed this wasn't a layout/paint-timing race (staggering
        // the DOM insertion across animation frames made no measurable
        // difference), just that lazysizes' MutationObserver appears to
        // unveil everything when several hundred `.lazyload` elements land
        // at once. Rather than fight that vendor behavior, these images are
        // pulled out of lazysizes' hands entirely before they're ever
        // connected to the page: `deferImages()` strips the `lazyload`
        // class and `data-src`/`data-srcset` off each imported node's
        // images (stashing the real URLs in `data-turbo-src`/
        // `data-turbo-srcset`) while the node is still a detached clone, so
        // lazysizes' observer never sees them at all — then a single
        // shared IntersectionObserver below assigns the real `src`/
        // `srcset` itself once an image actually scrolls near the
        // viewport. This only affects images that arrived through this
        // turbo-load path; every other image on the page keeps using
        // lazysizes exactly as before.
        var imageObserver = null;
        function getImageObserver() {
          if (!imageObserver) {
            imageObserver = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (!entry.isIntersecting) return;
                  imageObserver.unobserve(entry.target);
                  var img = entry.target;
                  var realSrcset = img.getAttribute('data-turbo-srcset');
                  var realSrc = img.getAttribute('data-turbo-src');
                  if (realSrcset) img.setAttribute('srcset', realSrcset);
                  if (realSrc) img.setAttribute('src', realSrc);
                  img.removeAttribute('data-turbo-src');
                  img.removeAttribute('data-turbo-srcset');
                });
              },
              { rootMargin: '800px 0px' }
            );
          }
          return imageObserver;
        }

        function deferImages(node) {
          if (!node.querySelectorAll) return;
          var imgs = node.querySelectorAll('img.lazyload');
          for (var di = 0; di < imgs.length; di++) {
            var img = imgs[di];
            var src = img.getAttribute('data-src');
            var srcset = img.getAttribute('data-srcset');
            if (!src && !srcset) continue;
            img.classList.remove('lazyload');
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
            if (src) img.setAttribute('data-turbo-src', src);
            if (srcset) img.setAttribute('data-turbo-srcset', srcset);
            getImageObserver().observe(img);
          }
        }

        function runBatch() {
          // The first batch is already sized to cover every real remaining
          // page when knownTotalPages is available (see above), so once
          // nextPage runs past that known total there is nothing left to
          // fetch — no need to send a whole extra wave of requests just to
          // watch them come back empty and confirm what's already known.
          // Live testing found that confirmatory wave surprisingly slow
          // (~8s for 16 past-the-end requests on Lingerie, likely Shopify/
          // CDN handling of out-of-range section renders), so skipping it
          // outright is what actually delivers the speedup, not just the
          // batch-sizing above. The empty-page check further down stays as
          // the authoritative fallback for when this count is missing,
          // unparsable, or goes stale (e.g. a Tag filter changes the real
          // page count after an AJAX swap) — this is purely a "don't ask a
          // question we already know the answer to" shortcut.
          if (!reachedEnd && knownTotalPages && nextPage > knownTotalPages) {
            reachedEnd = true;
          }

          if (reachedEnd) {
            allLoaded = true;
            loadInProgress = false;
            applyFilters();
            return;
          }

          var pages = [];
          for (var i = 0; i < batchSize; i++) pages.push(nextPage + i);
          nextPage += batchSize;

          Promise.allSettled(
            pages.map(function (p) {
              return fetchPage(p, 0);
            })
          ).then(function (results) {
            var frag = document.createDocumentFragment();
            var sawEmpty = false;
            for (var i = 0; i < results.length; i++) {
              var r = results[i];
              if (r.status === 'rejected') {
                // A real failure that survived retries — stop here rather
                // than guess. Anything already appended from earlier in
                // this same batch stays; nothing later in the batch (even
                // if it happened to succeed) is used, so there's no gap —
                // stepLoad() below picks up cleanly from this exact page.
                if (frag.childNodes.length) grid.appendChild(frag);
                refreshReviewBadges();
                turboFallback(loadMoreBtn, pages[i]);
                return;
              }
              if (r.value.length === 0) {
                // Round 45: this used to `break` here, discarding every
                // later result in the batch even if it had already fetched
                // real products successfully — that was Randy's "37 red
                // items" bug (Round 44): one page coming back empty (see the
                // fetchPage() retry hardening above for why that can happen)
                // silently threw away every page after it in the same batch.
                // Every result is now processed regardless of an earlier
                // empty one, so nothing already-fetched is ever discarded.
                //
                // Whether an empty result also means "the collection is
                // over" now depends on whether the real total is known:
                // when it is, fetchPage() above has already retried this
                // exact page against that total, so an empty result reaching
                // here is, at worst, one missed page rather than a reason to
                // stop — the top of runBatch() (nextPage > knownTotalPages)
                // is what actually and correctly ends the load in that case.
                // Only fall back to trusting "empty = the end" here when the
                // total isn't known at all — the same signal this always
                // relied on before Round 44.
                if (!knownTotalPages) sawEmpty = true;
                continue;
              }
              r.value.forEach(function (node) {
                var imported = document.importNode(node, true);
                deferImages(imported);
                frag.appendChild(imported);
              });
            }
            if (frag.childNodes.length) grid.appendChild(frag);
            refreshReviewBadges();
            if (sawEmpty) reachedEnd = true;
            runBatch();
          });
        }

        runBatch();
      }

      function loadRemainingPages() {
        if (allLoaded || loadInProgress) return;
        var loadMoreBtn = document.querySelector(LOAD_MORE_SELECTOR);
        if (!loadMoreBtn || !loadMoreBtn.offsetParent) {
          allLoaded = true;
          applyFilters();
          return;
        }
        loadInProgress = true;
        consecutiveStalls = 0;
        turboLoad(loadMoreBtn);
      }

      // Round 40's original click-and-poll loader. turboLoad() above is the
      // normal path now (see the Round 42 comment); this stays in place as
      // the proven fallback turboFallback() reaches for if a direct fetch
      // ever fails outright.
      function stepLoad() {
        var loadMoreBtn = document.querySelector(LOAD_MORE_SELECTOR);
        // This theme doesn't remove the "Load More" link once the
        // collection is exhausted — it just hides it (an "is-hidden" class,
        // display: none), leaving it in the DOM with its last-fetched href.
        // Checking only for the element's existence missed that, so this
        // kept "clicking" an invisible, inert button forever once the real
        // last page was reached. offsetParent is null for anything not
        // rendered (display: none among other cases), so it doubles as a
        // simple, dependency-free visibility check here.
        if (!loadMoreBtn || !loadMoreBtn.offsetParent) {
          allLoaded = true;
          loadInProgress = false;
          applyFilters();
          return;
        }

        var countBefore = grid.querySelectorAll('.product__grid-item').length;
        suppressOutsideClose = true;
        loadMoreBtn.click();
        suppressOutsideClose = false;

        // Poll rather than trust a single "no DOM change within 1.5s means
        // this was the last page" race: on a real storefront the AJAX
        // response can take anywhere from well under a second to several
        // seconds depending on network conditions, and treating "nothing's
        // happened yet" as "nothing's coming" concluded the collection was
        // fully loaded while it was still hundreds of products short —
        // freezing the result count on a plausible-looking but wrong
        // number, since once allLoaded flips true there's no going back.
        // Checking every 300ms for up to 12s per click, against BOTH real
        // completion signals (new items landed, or the theme hid the
        // button itself) rather than the mere absence of a mutation, means
        // a slow response is waited out instead of misread as "done."
        var elapsedMs = 0;
        var pollInterval = setInterval(function () {
          elapsedMs += 300;
          var btnNow = document.querySelector(LOAD_MORE_SELECTOR);
          var hiddenNow = !btnNow || !btnNow.offsetParent;
          var grew = grid.querySelectorAll('.product__grid-item').length !== countBefore;

          if (hiddenNow) {
            clearInterval(pollInterval);
            allLoaded = true;
            loadInProgress = false;
            applyFilters();
          } else if (grew) {
            clearInterval(pollInterval);
            consecutiveStalls = 0;
            stepLoad();
          } else if (elapsedMs >= 12000) {
            clearInterval(pollInterval);
            consecutiveStalls++;
            if (consecutiveStalls >= 3) {
              // Three full 12s waits with zero progress and the button
              // still showing — a real network/handler failure, not just
              // a slow response. Stop retrying and show whatever loaded
              // so far rather than leave the shopper on "Loading…"
              // indefinitely.
              allLoaded = true;
              loadInProgress = false;
              applyFilters();
            } else {
              stepLoad();
            }
          }
        }, 300);
      }

      function closeAllPanels() {
        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = b.parentElement.querySelector('[data-filter-panel]');
          if (p) p.hidden = true;
        });
      }

      // Round 43: fixes "the filters dropdowns are not showing on the mobile
      // version" (Randy). The panel is CSS-positioned relative to its own
      // (narrow — just the toggle button's width) `.collection-hub-filters__group`
      // wrapper: `left: 0` on desktop, `right: 0` on mobile (collection-hub.css).
      // That works fine when there's enough room on that side, but the SIZE
      // button is the leftmost filter on the row — on a narrow phone screen
      // its group sits only a small distance from the left edge, so anchoring
      // a 230px-wide panel to that group's RIGHT edge (`right: 0`) pushes most
      // of the panel's width past the left edge of the viewport and off-screen,
      // where it's clipped and invisible. It wasn't empty or hidden behind
      // anything — it was really there, just positioned almost entirely
      // outside the visible page. This nudges any panel that would overflow
      // either edge back on-screen with a corrective `transform`, measured
      // fresh every time a panel opens (so it self-adjusts to whatever
      // viewport width is active) rather than trying to hand-tune fixed CSS
      // offsets per button per breakpoint.
      function positionPanel(panel) {
        panel.style.transform = '';
        var margin = 8;
        var rect = panel.getBoundingClientRect();
        var shift = 0;
        if (rect.left < margin) {
          shift = margin - rect.left;
        } else if (rect.right > window.innerWidth - margin) {
          shift = window.innerWidth - margin - rect.right;
        }
        if (shift !== 0) {
          panel.style.transform = 'translateX(' + shift + 'px)';
        }
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var panel = btn.parentElement.querySelector('[data-filter-panel]');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAllPanels();
          if (!isOpen && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
            positionPanel(panel);
            // Start loading the rest of the collection as soon as the
            // shopper shows intent to filter (opening the panel), so the
            // remaining pages have a head start on loading by the time
            // they actually check a box.
            loadRemainingPages();
          }
        });
      });

      container.querySelectorAll('[data-filter-done]').forEach(function (doneBtn) {
        doneBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAllPanels();
        });
      });

      container.querySelectorAll('[data-filter-panel]').forEach(function (panel) {
        panel.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      document.addEventListener('click', function (e) {
        if (suppressOutsideClose) return;
        if (!container.contains(e.target)) closeAllPanels();
      });

      function getActive(type) {
        var inputs = container.querySelectorAll('[data-filter-input="' + type + '"]:checked');
        return Array.prototype.map.call(inputs, function (el) {
          return el.value;
        });
      }

      function applyFilters() {
        var items = grid.querySelectorAll('.product__grid-item');
        var activeSizes = getActive('size');
        var activeColors = getActive('color');
        var anyActive = activeSizes.length > 0 || activeColors.length > 0;
        var visible = 0;

        items.forEach(function (item) {
          var itemSizes = (item.getAttribute('data-hub-sizes') || '').split('|').filter(Boolean);
          var itemColors = (item.getAttribute('data-hub-colors') || '').split('|').filter(Boolean);
          var sizeMatch = activeSizes.length === 0 || activeSizes.some(function (s) {
            return itemSizes.indexOf(s) !== -1;
          });
          var colorMatch = activeColors.length === 0 || activeColors.some(function (c) {
            return itemColors.indexOf(c) !== -1;
          });
          var show = sizeMatch && colorMatch;
          item.classList.toggle('is-hub-filtered-out', !show);
          if (show) visible++;
        });

        container.querySelectorAll('[data-filter-group]').forEach(function (group) {
          var type = group.getAttribute('data-filter-group');
          var count = getActive(type).length;
          var badge = group.querySelector('[data-filter-count]');
          if (badge) badge.textContent = count ? '(' + count + ')' : '';
        });

        if (clearBtn) clearBtn.hidden = !anyActive;
        if (resultCount) {
          // Show "Loading…" instead of a count while loadRemainingPages()
          // above is still fetching further pages, rather than a small,
          // misleading number that only reflects whatever's loaded so far
          // (Round 40 — see loadRemainingPages() for the full story).
          resultCount.textContent = !anyActive
            ? ''
            : allLoaded
            ? visible + ' item' + (visible === 1 ? '' : 's')
            : 'Loading…';
        }

        var wrapper = grid.closest('.collection-matrix__wrapper') || grid.parentElement || grid;
        var emptyMsg = wrapper.querySelector('[data-hub-empty-message]');
        if (anyActive && visible === 0) {
          if (!emptyMsg) {
            emptyMsg = document.createElement('div');
            emptyMsg.setAttribute('data-hub-empty-message', '');
            emptyMsg.className = 'collection-hub-filters__empty';
            emptyMsg.textContent = 'No products match your filters. Try clearing a filter.';
            wrapper.appendChild(emptyMsg);
          }
          emptyMsg.hidden = false;
        } else if (emptyMsg) {
          emptyMsg.hidden = true;
        }

        // With the auto-loading pagination types (infinite_scroll /
        // infinite_load_more) filtering products out with display:none
        // shrinks the grid's height, which can leave the load trigger
        // sitting inside the viewport without the theme's Waypoints library
        // noticing (it only recalculates on scroll/resize) — nudging both
        // events after every filter pass fixes that. Under the current
        // "load_more" button pagination type this is a harmless no-op
        // (nothing auto-loads), which is intentional: batches only load
        // when the shopper clicks "Load More" themselves.
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));
      }

      container.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () {
          applyFilters();
          // Defensive: the panel-open handler above already kicks this off,
          // but loadRemainingPages() is a no-op once allLoaded is true, so
          // calling it again here just guarantees a filter change always
          // has the full collection loaded, however the panel got opened.
          loadRemainingPages();
        });
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          container.querySelectorAll('[data-filter-input]:checked').forEach(function (input) {
            input.checked = false;
          });
          applyFilters();
        });
      }

      // The theme's native infinite scroll (Waypoints) appends new
      // .product__grid-item nodes into the grid as the shopper scrolls.
      // Without this observer, Size/Color filters only ever evaluated
      // whatever page was in the DOM when the shopper opened the filter —
      // re-running applyFilters() whenever new items land keeps the active
      // filter selections applied across the entire collection, not just
      // the first batch.
      var gridObserver = null;
      function observeGrid(node) {
        if (gridObserver) gridObserver.disconnect();
        gridObserver = new MutationObserver(function (mutations) {
          var added = mutations.some(function (m) {
            return m.addedNodes && m.addedNodes.length > 0;
          });
          if (added) applyFilters();
        });
        gridObserver.observe(node, { childList: true });
      }
      observeGrid(grid);

      // Round 39: fixes "filters work until you apply sort" (Randy). The
      // theme's own Sort/Tag AJAX filtering (assets/z__jsCollection.js,
      // updateView()) doesn't append into this existing grid element the
      // way native "Load More" does above — on every Sort or Tag change it
      // does `$('[data-collection-main]').empty()` then appends a brand
      // new `.collection-matrix` fetched fresh from the server. That fresh
      // markup carries none of the `is-hub-filtered-out` classes, and the
      // gridObserver above is left watching the OLD, now-detached grid
      // node, so it never fires for the replacement — any active
      // Size/Color selection silently stopped applying to the product list
      // the moment Sort (or a Tag filter, same code path) was touched,
      // while the Size/Color checkboxes and result count stayed exactly as
      // they were, looking selected/active but doing nothing. Watching the
      // stable parent wrapper ([data-collection-main], which
      // z__jsCollection.js empties and refills but never itself replaces)
      // for childList changes catches that swap: grab whatever
      // `.collection-matrix` node is inside it now, re-run applyFilters()
      // against it so the current Size/Color selections keep hiding the
      // right products, and re-point the grid-level observer above at the
      // new node so Load More keeps working on it too.
      var collectionMain = document.querySelector('[data-collection-main]');
      if (collectionMain) {
        new MutationObserver(function () {
          var newGrid = collectionMain.querySelector('.collection-matrix');
          if (newGrid && newGrid !== grid) {
            grid = newGrid;
            // Round 40: the freshly-sorted/tag-filtered grid the AJAX
            // handler just swapped in only carries its own first page —
            // reset the "whole collection is loaded" flag so a Size/Color
            // filter still active after a Sort change re-triggers the
            // catch-up load against the new (re-sorted) product order,
            // instead of treating the old grid's "fully loaded" state as if
            // it still applied here.
            allLoaded = false;
            loadInProgress = false;
            observeGrid(grid);
            applyFilters();
            if (getActive('size').length || getActive('color').length) {
              loadRemainingPages();
            }
          }
        }).observe(collectionMain, { childList: true });
      }
    });
  }

  function initSubcategoryBar() {
    var bars = document.querySelectorAll('[data-subcat-bar]');
    if (!bars.length) return;

    bars.forEach(function (wrap) {
      var scroller = wrap.querySelector('[data-subcat-scroll]');
      var prevBtn = wrap.querySelector('[data-subcat-prev]');
      var nextBtn = wrap.querySelector('[data-subcat-next]');
      if (!scroller) return;

      function updateEdges() {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var hasOverflow = maxScroll > 4;
        var atStart = scroller.scrollLeft <= 4;
        var atEnd = scroller.scrollLeft >= maxScroll - 4;

        wrap.classList.toggle('is-scrolled-left', hasOverflow && !atStart);
        wrap.classList.toggle('is-scrollable-right', hasOverflow && !atEnd);

        if (prevBtn) prevBtn.hidden = !hasOverflow || atStart;
        if (nextBtn) nextBtn.hidden = !hasOverflow || atEnd;
      }

      var scrollAmount = function () {
        return Math.max(scroller.clientWidth * 0.7, 160);
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      scroller.addEventListener('scroll', updateEdges);
      window.addEventListener('resize', updateEdges);
      updateEdges();

      // Click-and-drag scrolling for desktop mouse users (touch/trackpad
      // already scroll natively via overflow-x). On collections where the
      // bar wraps onto multiple rows instead of scrolling (see the
      // `--wrap-rows` modifier in collection-hub.css), scroller.scrollWidth
      // ends up equal to clientWidth, updateEdges() above finds no
      // overflow, and this drag handling simply never has anything to do —
      // no extra guard needed here.
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var dragged = false;

      scroller.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        startX = e.pageX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var delta = e.pageX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        scroller.scrollLeft = startScrollLeft - delta;
      });

      // Suppress the click-through to a link if the user was actually
      // dragging rather than clicking
      scroller.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (dragged) {
            e.preventDefault();
            dragged = false;
          }
        });
      });
    });
  }

  function initPrefetchNextPage() {
    // Quietly warms the browser's own HTTP cache for the next "Load More"
    // page while the shopper is just browsing, so both a manual "Load
    // More" click and the catch-up restoration below (initScrollRestoration)
    // have a good chance of resolving straight from cache instead of
    // waiting on a fresh round trip.
    var grid = document.querySelector('.collection-matrix');
    if (!grid) return;

    var loadMoreSelector = '[data-load-more], [data-load-infinite], [data-load-more-infinite]';
    var prefetchedHref = null;

    function prefetchNext() {
      var loadMoreEl = document.querySelector(loadMoreSelector);
      var href = loadMoreEl ? loadMoreEl.getAttribute('href') : null;
      if (!href || href === prefetchedHref) return;
      prefetchedHref = href;

      var run = function () {
        fetch(href, { credentials: 'same-origin' }).catch(function () {});
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 800);
      }
    }

    prefetchNext();
    new MutationObserver(prefetchNext).observe(grid, { childList: true });
  }

  function initScrollRestoration() {
    // What was landing shoppers in the footer: when this page isn't
    // eligible for the browser's back/forward cache (bfcache) — common on
    // theme pages carrying analytics beacons, chat widgets, etc. — hitting
    // Back does a full fresh reload. That reload only renders page 1 (the
    // first pagination_limit items), which is much SHORTER than the page
    // was when the shopper had clicked "Load More" a few times. The
    // browser's own automatic scroll restoration still tries to jump to
    // the old (tall-page) Y offset, and since that offset no longer
    // exists on the short page, it clamps to the max scroll — the very
    // bottom, i.e. the footer.
    //
    // The fix: take manual control of scroll restoration, remember how
    // many products were loaded + how far the shopper had scrolled, and
    // on the way back, catch the grid up to that same item count (via the
    // theme's own real "Load More" click handling — cheap here since
    // initPrefetchNextPage above already warms the first hop) before
    // scrolling to the saved position. This grows the page a little
    // before settling, which reads as it catching up rather than as a
    // second reload, and it always lands in the right place instead of
    // wherever the shorter page happened to clamp to.
    var grid = document.querySelector('.collection-matrix');
    if (!grid) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var storageKey = 'hubScroll:' + location.pathname + location.search;

    function itemCount() {
      return grid.querySelectorAll('.product__grid-item').length;
    }

    function saveState() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ count: itemCount(), y: window.scrollY }));
      } catch (e) {}
    }

    // Round 12 fix: read whatever the PREVIOUS view of this page saved
    // (via the pagehide listener below) BEFORE anything on this fresh
    // load gets a chance to overwrite it. Earlier rounds called
    // saveState() once immediately here to "establish a baseline" — but
    // that ran before this read, so on every fresh reload it clobbered
    // the real saved snapshot with the just-loaded page's OWN state
    // (count = however many items page 1 has, y = 0, since we're at the
    // top of a brand-new load). The restore logic below was then always
    // comparing the fresh page against itself — itemCount() >= saved.count
    // was trivially true and saved.y was always 0 — so it silently did
    // nothing every single time, regardless of what actually shipped in
    // rounds 9-11. Reading first — before any save happens on this
    // view — is what makes the saved snapshot from the *prior* view
    // actually reach the restore logic below.
    var raw;
    try {
      raw = sessionStorage.getItem(storageKey);
    } catch (e) {
      raw = null;
    }

    var saveTimer;
    function scheduleSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveState, 200);
    }
    window.addEventListener('scroll', scheduleSave, { passive: true });
    new MutationObserver(scheduleSave).observe(grid, { childList: true });

    // pagehide fires reliably at the moment the page is actually being
    // left (including right before a bfcache freeze) — this is the save
    // that matters, with no debounce, so a scroll or Load More click
    // right before the shopper clicks into a product is never lost to a
    // pending 200ms timer. visibilitychange (hidden) is added as a
    // second, earlier-firing safety net: pagehide has known ordering
    // quirks on mobile Safari, and visibilitychange is the
    // cross-browser-recommended fallback for "the shopper is leaving."
    window.addEventListener('pagehide', saveState);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });

    // Only attempt the catch-up/restore on an actual back/forward
    // navigation — a plain link click into this same URL should just
    // load fresh at the top like normal. If the Navigation Timing API
    // isn't available to tell us, err on the side of attempting the
    // restore rather than silently leaving the shopper at the top.
    var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    var navType = navEntries && navEntries[0] && navEntries[0].type;
    if (navType && navType !== 'back_forward') return;

    if (!raw) return;

    var saved;
    try {
      saved = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!saved || !saved.count || itemCount() >= saved.count) {
      if (saved && saved.y) {
        requestAnimationFrame(function () {
          window.scrollTo(0, saved.y);
        });
      }
      return;
    }

    var attempts = 0;
    var maxAttempts = 30;

    function finish() {
      requestAnimationFrame(function () {
        window.scrollTo(0, saved.y);
      });
    }

    function growAndRestore() {
      attempts++;
      var loadMoreBtn = document.querySelector(
        '[data-load-more], [data-load-infinite], [data-load-more-infinite]'
      );
      if (itemCount() >= saved.count || !loadMoreBtn || attempts > maxAttempts) {
        finish();
        return;
      }

      var countBefore = itemCount();
      loadMoreBtn.click();

      var settleTimer;
      var observer = new MutationObserver(function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          observer.disconnect();
          growAndRestore();
        }, 150);
      });
      observer.observe(grid, { childList: true });

      // Safety net in case that click didn't append anything (e.g. the
      // theme's handler wasn't ready yet, or this really was the last page)
      settleTimer = setTimeout(function () {
        observer.disconnect();
        if (itemCount() === countBefore) {
          finish();
        } else {
          growAndRestore();
        }
      }, 1500);
    }

    growAndRestore();
  }

  function initNativeLoadMore() {
    // The theme's own "Load More" / infinite-scroll click handling
    // (window.PXUTheme.infiniteScroll.init(), defined in utilities.js) is
    // normally wired up by app.js's 'shopify:section:load' listener — but
    // that event only fires inside the Shopify theme editor, never on a
    // plain storefront page view. Without it, the [data-load-more] link
    // never gets its click intercepted, so clicking "Load More" just
    // follows the link's href like a normal browser navigation — a full
    // page reload back to page 1, losing scroll position/filters. Calling
    // init() here (it uses delegated jQuery events + does its own .off()
    // before .on(), so it's safe to call more than once) makes the button
    // actually work on a real page load, matching how it already behaves
    // in the theme editor.
    if (
      window.PXUTheme &&
      window.PXUTheme.infiniteScroll &&
      typeof window.PXUTheme.infiniteScroll.init === 'function'
    ) {
      window.PXUTheme.infiniteScroll.init();
    }
  }

  function initVideoTiles() {
    var tiles = document.querySelectorAll('[data-hub-video]');
    if (!tiles.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );

    tiles.forEach(function (tile) {
      observer.observe(tile);
    });
  }

  // Collection Hub: product-card photo-cycle arrows. Lets a shopper click
  // through every photo a product has without leaving the collection page.
  // Uses one delegated click listener on `document` instead of binding a
  // listener per card, so it works the same for the initial page-1 cards and
  // for every card the turbo-loader appends later — no rebinding needed.
  // Each photo beyond the first is only fetched the moment it's actually
  // requested by a click, on purpose: rendering every photo for every
  // product up front would reproduce the exact eager-image cost Round 46
  // just fixed, just triggered by a different mechanism (photo count instead
  // of product count).
  function initPhotoNav() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hub-photo-prev], [data-hub-photo-next]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var nav = btn.closest('[data-hub-photo-nav]');
      if (!nav) return;

      var photos;
      try {
        photos = JSON.parse(nav.getAttribute('data-hub-photos') || '[]');
      } catch (err) {
        return;
      }
      if (!photos.length) return;

      var current = parseInt(nav.getAttribute('data-hub-photo-index'), 10) || 0;
      var direction = btn.hasAttribute('data-hub-photo-next') ? 1 : -1;
      var next = (current + direction + photos.length) % photos.length;
      var nextPhoto = photos[next];
      if (!nextPhoto || !nextPhoto.src) return;

      var imageContainer = nav.parentElement;
      var img = imageContainer && imageContainer.querySelector('.hub-photo-img');
      if (img) {
        // Drop lazysizes' own attributes first so a late unveil can't
        // clobber the manual swap we're about to make.
        img.classList.remove('lazyload');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = nextPhoto.src;
      }

      nav.setAttribute('data-hub-photo-index', String(next));
    });
  }

  function init() {
    initFilters();
    initSubcategoryBar();
    initNativeLoadMore();
    initPrefetchNextPage();
    initScrollRestoration();
    initVideoTiles();
    initPhotoNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
